<script lang="ts">
    import src from './svg/add_circle_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import WhiteColor from '../WhiteColor.svelte';
    export let scale: number = 1;
    export let title: string = '';
</script>

<WhiteColor>
    <TemplateIcon {src} {scale} alt={title} hover={title} on:click />
</WhiteColor>
